import { useState } from "react"
import { createFileRoute, Navigate } from "@tanstack/react-router"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { useLogin } from "@/lib/hooks/use-auth"
import { useAuthStore } from "@/stores/auth-store"
import bkwaiLogo from "@/assets/bkwai_logo.png"

export const Route = createFileRoute("/login")({
  component: LoginPage,
})

function LoginPage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const { mutate: login, isPending, error } = useLogin()

  if (isAuthenticated) {
    return <Navigate to="/" />
  }

  return (
    <div className="flex h-screen items-center justify-center bg-[var(--color-bg-primary)]">
      <div className="w-full max-w-sm space-y-6 rounded-[var(--radius-panel)] border border-[var(--color-border-subtle)] bg-[var(--color-bg-secondary)] p-8">
        <div className="text-center">
          <img src={bkwaiLogo} alt="BKwai" className="mx-auto h-8" />
          <p className="mt-3 text-sm text-[var(--color-text-secondary)]">
            Sign in to your account
          </p>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault()
            login({ email, password })
          }}
          className="space-y-4"
          aria-label="Sign in form"
        >
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium text-[var(--color-text-secondary)]">
              Email
            </label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              aria-label="Email address"
              required
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-medium text-[var(--color-text-secondary)]">
              Password
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
              aria-label="Password"
              required
            />
          </div>

          {error && (
            <p className="text-sm text-[var(--color-accent-red)]">
              Invalid credentials. Please try again.
            </p>
          )}

          <Button type="submit" className="w-full" disabled={isPending}>
            {isPending ? "Signing in..." : "Sign in"}
          </Button>

          <div className="text-center">
            <a
              href="/forgot-password"
              className="text-xs text-[var(--color-text-muted)] hover:text-[var(--color-accent-blue)] transition-colors"
            >
              Forgot password?
            </a>
          </div>
        </form>
      </div>
    </div>
  )
}
